import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ActivityOrigin } from 'libs.ecoa_shared';
import { DOCUMENT_TYPE_CONFIG } from '../constants';
import { useImportState } from '../contexts/import_state.context';
import { DocumentTypeStep } from '../document_type_step.component';
import { ImportDocumentTypeSelection } from '../import_document_type_selection.component';
import { ImportMedableFormat } from '../import_medable_format.component';
import { SelectLocale } from '../select_locale.component';
import { UploadNonMedableFiles } from '../upload_non_medable_files.component';
import { WithCloneVersionActivity } from '../with_clone_version_activity.component';
export const useImportSteps = (params) => {
    const { documentType, setDocumentType, assetId, origin = ActivityOrigin.ORIGINAL, activity, isSourceTranslationsAvailable = false, } = params;
    const { files, localeMap, setLocaleMap } = useImportState();
    return useMemo(() => {
        const baseSteps = [
            _jsx(ImportDocumentTypeSelection, { documentType: documentType || 'NO_OP', setDocumentType: setDocumentType, origin: origin, isSourceTranslationsAvailable: isSourceTranslationsAvailable }, '1'),
        ];
        const config = documentType ? DOCUMENT_TYPE_CONFIG[documentType] : undefined;
        if (documentType === 'MEDABLE_FORMAT' && config) {
            baseSteps.push(_jsx(ImportMedableFormat, {}, config.key));
        }
        else if (documentType === 'NON_MEDABLE_FORMAT') {
            // Step 2: File upload
            baseSteps.push(_jsx(UploadNonMedableFiles, { assetId: assetId }, 'key_NON_MEDABLE_FORMAT'));
            // Step 3: Locale selection
            baseSteps.push(_jsx(SelectLocale, { files: files, localeMap: localeMap, onLocaleChange: setLocaleMap }, '3'));
        }
        else if (documentType === 'MEDABLE_FORMAT_EXISTING_CLONE' || documentType === 'MEDABLE_FORMAT_EXISTING_VERSION') {
            baseSteps.push(_jsx(WithCloneVersionActivity, { activity: activity }, 'key_MEDABLE_FORMAT_EXISTING_CLONE_VERSION'));
        }
        else {
            // This ghost step is here so that Step 1 (even when unselected) can show a "Continue" button to proceed to the next step
            baseSteps.push(_jsx(DocumentTypeStep, {}, 'ghost'));
        }
        return baseSteps;
    }, [documentType, setDocumentType, files, localeMap, setLocaleMap, assetId, origin, isSourceTranslationsAvailable]);
};
